/**
 * Display-time brand normalization.
 * Do not mutate historical AI-review audit JSON — only replace the exact
 * legacy product-name token when rendering user-visible text.
 */
export const PRODUCT_NAME = 'DealSkout';
export const LEGACY_PRODUCT_NAME = 'DealScout';

export function replaceLegacyBrand(text: string | null | undefined): string {
  if (text == null || text === '') return '';
  return String(text).split(LEGACY_PRODUCT_NAME).join(PRODUCT_NAME);
}
